import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { Button } from '@/components/ui/button';
import DashboardLayout from '@/components/layout/DashboardLayout';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export default function UserDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data: user } = useQuery({
    queryKey: ['admin-user', id],
    queryFn: async () => {
      const { data } = await supabase
        .from('users')
        .select('id, email, first_name, last_name, subscription_type, created_at')
        .eq('id', id)
        .maybeSingle();
      return data as any;
    },
    enabled: !!id,
  });

  const { data: sessions } = useQuery({
    queryKey: ['admin-user-sessions', id],
    queryFn: async () => {
      const { data } = await supabase
        .from('chat_sessions')
        .select('id, posit_id, session_type, created_at, updated_at')
        .eq('created_by', id)
        .order('updated_at', { ascending: false })
        .limit(50);
      return (data || []) as any[];
    },
    enabled: !!id,
  });

  return (
    <DashboardLayout title="User" maxWidth="6xl" headerActions={<Button variant="outline" onClick={() => navigate('/admin/business/users')}>Back</Button>}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="p-4 border rounded-lg md:col-span-1">
            <div className="space-y-1">
              <div className="text-sm text-muted-foreground">Email</div>
              <div className="font-medium">{user?.email || '—'}</div>
            </div>
            <div className="space-y-1 mt-4">
              <div className="text-sm text-muted-foreground">Name</div>
              <div className="font-medium">{[user?.first_name, user?.last_name].filter(Boolean).join(' ') || '—'}</div>
            </div>
            <div className="space-y-1 mt-4">
              <div className="text-sm text-muted-foreground">Subscription</div>
              <div className="font-medium">{user?.subscription_type || '—'}</div>
            </div>
            <div className="space-y-1 mt-4">
              <div className="text-sm text-muted-foreground">Joined</div>
              <div className="font-medium">{user?.created_at ? new Date(user.created_at).toLocaleString() : '—'}</div>
            </div>
          </div>
          <div className="p-4 border rounded-lg md:col-span-2">
            <div className="flex items-center justify-between mb-2">
              <h2 className="font-semibold">Recent Sessions</h2>
            </div>
            <div className="border rounded-lg">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>ID</TableHead>
                    <TableHead>Posit</TableHead>
                    <TableHead>Type</TableHead>
                    <TableHead>Updated</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {(sessions || []).map((s) => (
                    <TableRow key={s.id}>
                      <TableCell className="font-mono text-xs">{s.id}</TableCell>
                      <TableCell className="font-mono text-xs">{s.posit_id}</TableCell>
                      <TableCell>{s.session_type}</TableCell>
                      <TableCell>{new Date(s.updated_at).toLocaleString()}</TableCell>
                    </TableRow>
                  ))}
                  {(sessions || []).length === 0 && (
                    <TableRow>
                      <TableCell colSpan={4} className="text-center text-muted-foreground">No sessions found</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>
          </div>
        </div>
    </DashboardLayout>
  );
}

